export default __webpack_public_path__ + "static/media/Beard_2_C4.589a5984.svg";